import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../store';  // Asegúrate de exportar AppDispatch desde tu store

export const useAppDispatch = () => useDispatch<AppDispatch>();